import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/**
 * Helper function for working with Vuelidate.
 */
Vue.prototype.$invalidInput = function() {
  this.$v.$touch()
  return this.$v.$invalid ? true : false
}
